import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackClick } from '../../services/landingAnalytics';

const API = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const [tcMeta, setTcMeta] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/tc/document`)
      .then((r) => r.ok ? r.json() : null)
      .then((j) => { if (j?.ok) setTcMeta({ version: j.version, effective_date: j.effective_date }); })
      .catch(() => {});
  }, []);

  const goLegal = (anchor) => () => {
    trackClick(`footer-${anchor}`, 'footer');
    navigate(`/legal#${anchor}`);
  };

  return (
    <footer
      className="bg-[#0B1120] text-slate-400 py-16"
      data-testid="landing-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img src="/icon-192.png" alt="" className="w-9 h-9 rounded-lg" />
              <span
                className="text-lg font-bold tracking-tight text-white"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                GateKeeper <span className="text-[#14D4C6]">Pro</span>
              </span>
            </div>
            <p
              className="mt-4 text-sm leading-relaxed max-w-md"
              style={{ fontFamily: 'Work Sans, sans-serif' }}
            >
              Smarter security. Simpler society life. Built for residential
              communities of every size.
            </p>
          </div>

          <div className="md:col-span-2">
            <h5
              className="text-xs font-semibold uppercase tracking-wide text-white mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Product
            </h5>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#features" className="hover:text-white transition-colors" data-testid="footer-link-features">
                  Features
                </a>
              </li>
              <li>
                <a href="#audience" className="hover:text-white transition-colors" data-testid="footer-link-audience">
                  For You
                </a>
              </li>
              <li>
                <a href="#how" className="hover:text-white transition-colors" data-testid="footer-link-how">
                  How it works
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-white transition-colors" data-testid="footer-link-faq">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h5
              className="text-xs font-semibold uppercase tracking-wide text-white mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Company
            </h5>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#demo" className="hover:text-white transition-colors" data-testid="footer-link-demo">
                  Book a demo
                </a>
              </li>
              <li>
                <a href="mailto:hello@gatekeeper.homes" className="hover:text-white transition-colors" data-testid="footer-link-contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h5
              className="text-xs font-semibold uppercase tracking-wide text-white mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Already a member?
            </h5>
            <button
              onClick={() => {
                trackClick('footer-login', 'footer');
                navigate('/login');
              }}
              className="text-sm font-semibold text-slate-900 bg-[#14D4C6] hover:bg-[#10B5A9] px-5 py-2.5 rounded-md transition-colors"
              data-testid="footer-login-btn"
            >
              Login →
            </button>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs">
          <span data-testid="footer-copyright">
            © {year} GateKeeper Pro. All rights reserved.
          </span>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {tcMeta && (
              <span
                className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-white/5 border border-white/10 text-[11px] text-slate-300"
                data-testid="footer-tc-updated"
                title={`T&C version ${tcMeta.version}`}
              >
                Updated {tcMeta.effective_date}
              </span>
            )}
            <button
              onClick={goLegal('privacy')}
              className="hover:text-white transition-colors"
              data-testid="footer-link-privacy"
            >
              Privacy
            </button>
            <button
              onClick={goLegal('terms')}
              className="hover:text-white transition-colors"
              data-testid="footer-link-terms"
            >
              Terms
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
